/**
 * 背景色スクロールアニメーション
 *
 * data-bg-color-scroll を付与した要素、または data-bg-color-target の対象要素の背景色を、
 * スクロール量に応じて data-bg-color-from から data-bg-color-to へ変化させる。
 * data-bg-color-use-vars を付与した要素は CSS カスタムプロパティ経由で制御する。
 * テキスト色・ボーダー色は data-text-color-from/to, data-border-color-from/to で制御できる。
 * data-bg-color-extra-var を付与した要素は追加の CSS カスタムプロパティも同時に制御する。
 * data-bg-pattern-scroll を付与した要素はパターン背景の opacity も同時に制御する。
 * data-grid-dark-overlay を付与した要素は ::before の暗グリッドオーバーレイも
 * 同時にフェードアウトさせる（CSS カスタムプロパティ --grid-dark-opacity 経由）。
 */
document.addEventListener("DOMContentLoaded", function () {
  var targets = document.querySelectorAll("[data-bg-color-scroll]");

  if (!targets.length) return;

  if (
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }

  window.gsap.registerPlugin(window.ScrollTrigger);

  targets.forEach(function (trigger) {
    var animationTargets = trigger.dataset.bgColorTarget
      ? document.querySelectorAll(trigger.dataset.bgColorTarget)
      : trigger;

    if (!animationTargets.length && animationTargets !== trigger) return;

    var fromColor = trigger.dataset.bgColorFrom || "#111111";
    var toColor = trigger.dataset.bgColorTo || "#ffffff";
    var useVars = trigger.hasAttribute("data-bg-color-use-vars");
    var scrubValue = trigger.dataset.bgColorScrub
      ? Number(trigger.dataset.bgColorScrub)
      : true;
    var scrub = Number.isNaN(scrubValue) ? true : scrubValue;

    var triggerOpts = {
      trigger: trigger,
      start: trigger.dataset.bgColorStart || "top bottom",
      end: trigger.dataset.bgColorEnd || "top top",
      scrub: scrub,
    };

    var fromObj = useVars
      ? { "--scroll-bg-color": fromColor }
      : { backgroundColor: fromColor };
    var toObj = {
      ease: "none",
      scrollTrigger: triggerOpts,
    };

    if (useVars) {
      toObj["--scroll-bg-color"] = toColor;
      if (trigger.dataset.textColorFrom) {
        fromObj["--scroll-text-color"] = trigger.dataset.textColorFrom;
      }
      if (trigger.dataset.textColorTo) {
        toObj["--scroll-text-color"] = trigger.dataset.textColorTo;
      }
      if (trigger.dataset.borderColorFrom) {
        fromObj["--scroll-border-color"] = trigger.dataset.borderColorFrom;
        fromObj["--bg-line-color"] = trigger.dataset.borderColorFrom;
      }
      if (trigger.dataset.borderColorTo) {
        toObj["--scroll-border-color"] = trigger.dataset.borderColorTo;
        toObj["--bg-line-color"] = trigger.dataset.borderColorTo;
      }
      if (trigger.dataset.bgColorExtraVar) {
        fromObj[trigger.dataset.bgColorExtraVar] =
          trigger.dataset.bgColorExtraFrom || fromColor;
        toObj[trigger.dataset.bgColorExtraVar] =
          trigger.dataset.bgColorExtraTo || toColor;
      }
    } else {
      toObj.backgroundColor = toColor;
      if (trigger.dataset.textColorFrom) {
        fromObj.color = trigger.dataset.textColorFrom;
      }
      if (trigger.dataset.textColorTo) {
        toObj.color = trigger.dataset.textColorTo;
      }
      if (trigger.dataset.borderColorFrom) {
        fromObj.borderColor = trigger.dataset.borderColorFrom;
      }
      if (trigger.dataset.borderColorTo) {
        toObj.borderColor = trigger.dataset.borderColorTo;
      }
    }

    if (trigger.hasAttribute("data-bg-pattern-scroll")) {
      fromObj["--scroll-pattern-opacity"] =
        trigger.dataset.bgPatternFrom || 0;
      toObj["--scroll-pattern-opacity"] = trigger.dataset.bgPatternTo || 1;
    }

    window.gsap.fromTo(animationTargets, fromObj, toObj);

    // 変更: data-grid-dark-overlay 属性がある場合、::before の暗グリッドを同時にフェードアウト
    if (trigger.hasAttribute("data-grid-dark-overlay")) {
      window.gsap.fromTo(
        animationTargets,
        { "--grid-dark-opacity": 1 },
        {
          "--grid-dark-opacity": 0,
          ease: "none",
          scrollTrigger: Object.assign({}, triggerOpts),
        },
      );
    }
  });
});
